module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ChapTitle"
  }, [_c('a', {
    attrs: {
      "id": "HLD3"
    }
  }), _vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("Putting together this collection of wool appliqué projects has been challenging and fun. The experience has stretched my creativity and has caused me to take a closer look not only at how I stitch and build a piece of art, but also at how I take it apart. This has allowed me to better understand my work and why I do things a certain way.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("When the idea of writing this book began to take shape, I wanted to fill it with a variety of projects. I did not want to write a book of rules. On the contrary, I would like it to be a guide for the beginner and a new challenge for the seasoned stitcher.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("In this book, you will find original and exciting wool appliqué patterns and the step-by-step instructions for completing them. As color is an important part of these projects, I have carefully chosen hues and shades that inspire those of us who love the nineteenth-century period and style. The hues have a beauty that I hope you can use and appreciate in your own home.")]), _vm._v(" "), _c('p', {
    staticClass: "txt"
  }, [_vm._v("My true hope is that you enjoy the projects and find your own inspiration in these pages.")]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg7_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg8_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60f7de48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_chapter03.vue
// module id = 69
// module chunks = 0